var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.50011L19.0001 13.0002H15.1V18.2003H9.89996V13.0002H5.9999L12.5 6.50011ZM24.2002 18.8503C24.2002 19.3443 23.9272 19.7733 23.5112 19.9943L13.241 25.7664C13.033 25.9224 12.773 26.0004 12.5 26.0004C12.227 26.0004 11.967 25.9224 11.759 25.7664L1.48882 19.9943C1.2804 19.8848 1.10598 19.7203 0.984508 19.5186C0.863035 19.3169 0.799156 19.0858 0.79981 18.8503V7.15012C0.79981 6.65611 1.07281 6.2271 1.48882 6.0061L11.759 0.234004C11.967 0.0780014 12.227 0 12.5 0C12.773 0 13.033 0.0780014 13.241 0.234004L23.5112 6.0061C23.9272 6.2271 24.2002 6.65611 24.2002 7.15012V18.8503ZM12.5 2.79505L3.39985 7.91713V18.0833L12.5 23.2054L21.6002 18.0833V7.91713L12.5 2.79505Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopIcon);
export default __webpack_public_path__ + "static/media/top-icon.5a4017ebf7981241821495f31ab236ae.svg";
export { ForwardRef as ReactComponent };